/**
 * @desc 分页
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.IPage<defs.basics.CertFileResponseDto>>;
export function request(params: API.basics.certFile.page.Params, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/certFile/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
